import { FC, useEffect, useState } from "react";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { Formik } from "formik";
import { Divider, FormLabel, Grid, TextField } from "@mui/material";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { RoutesMap } from "../../types";
import { useNavigate } from "react-router-dom";
import { useCompanyStore } from "../../hooks/useCompanyStore";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { ApiStatus } from "../../types/api/status";
import { Company } from "../../types/slices/companyType";
import { CustomPhoneInput } from "../../components/common/CustomPhoneInput/CustomPhoneInput";

type CompanyDataForm = {
    id: number
    rut: string
    business_name: string
    address: string
    email: string
    phone: string
}

export const CompanyForm: FC = () => {

    const navigate = useNavigate()
    const { status: companyStatus, selectedCompany, createCompany, editCompany, setSelectedCompany } = useCompanyStore()
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [data, setData] = useState<CompanyDataForm>({
        id: 0,
        rut: '',
        business_name: '',
        address: '',
        email: '',
        phone: ''
    })

    useEffect(() => {
        if (Object.entries(selectedCompany).length > 0) {
            setIsEdit(true)
            setData({
                id: selectedCompany.id,
                rut: selectedCompany.rut,
                business_name: selectedCompany.business_name,
                address: selectedCompany.address,
                email: selectedCompany.email,
                phone: selectedCompany.phone
            })
            setSelectedCompany({} as Company)
        }
    }, [])

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.business_name) errors.business_name = "Nombre es requerido";
        if (!values.rut) errors.rut = "RUT es requerido";
        if (!values.address) errors.address = "Dirección es requerido";
        if (!values.email) errors.email = "Email es requerido";
        if (!values.phone) errors.phone = "Celular es requerido";
        return errors;
    }

    const onSubmit = async (values) => {
        const method = !isEdit ? createCompany(values) : editCompany(data.id, values)
        const response = await method
        if (response === true) {
            navigate({ pathname: RoutesMap.COMPANY })
        }
    }

    const onCancel = async () => {
        navigate({ pathname: RoutesMap.COMPANY })
    }

    return (
        <CustomForm>
            {companyStatus === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <CustomFormHeader
                title={!isEdit ? 'Nueva Empresa' : 'Editar Empresa'}
                text={!isEdit ? 'Ingrese los datos de la nueva empresa' : 'Ingrese los datos de la nueva empresa'}
                goBack={RoutesMap.COMPANY}
            >
            </CustomFormHeader>
            <CustomFormBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Razón Social:</FormLabel>
                                            <TextField
                                                id="business_name"
                                                type="text"
                                                name="business_name"
                                                fullWidth
                                                size="small"
                                                value={values.business_name}
                                                onChange={handleChange}
                                                error={errors.business_name && touched.business_name ? true : false}
                                                helperText={errors.business_name && touched.business_name ? errors.business_name : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>RUT:</FormLabel>
                                            <TextField
                                                id="rut"
                                                type="text"
                                                name="rut"
                                                fullWidth
                                                size="small"
                                                value={values.rut}
                                                onChange={handleChange}
                                                error={errors.rut && touched.rut ? true : false}
                                                helperText={errors.rut && touched.rut ? errors.rut : ''}
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 10
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Dirección:</FormLabel>
                                            <TextField
                                                id="address"
                                                type="text"
                                                name="address"
                                                fullWidth
                                                size="small"
                                                value={values.address}
                                                onChange={handleChange}
                                                error={errors.address && touched.address ? true : false}
                                                helperText={errors.address && touched.address ? errors.address : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Email:</FormLabel>
                                            <TextField
                                                id="email"
                                                type="email"
                                                name="email"
                                                fullWidth
                                                size="small"
                                                value={values.email}
                                                onChange={handleChange}
                                                error={errors.email && touched.email ? true : false}
                                                helperText={errors.email && touched.email ? errors.email : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Celular:</FormLabel>
                                            <CustomPhoneInput value={values.phone} setting={setFieldValue} errors={errors} touched={touched} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <CustomFormFooter
                                    buttonType="submit"
                                    confirmText={!isEdit ? 'Guardar' : 'Actualizar'}
                                    cancelText={"Cancelar"}
                                    onConfirm={handleSubmit}
                                    onCancel={onCancel}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </CustomFormBody>
        </CustomForm>
    )
}